import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

import { StarCntBtn } from '../common';
import useStarShop from '../../hooks/useStarShop';
import { toDate } from '../../utils/utilityEtc';
import { useUserInfo } from '../../hooks';
import { TYPE } from '../../constant';
import StarShopBtn from './StarShopBtn';

function StarShopHistory() {
  const { info } = useUserInfo();
  const [page, setPage] = useState(1);
  const [pageCnt, setPageCnt] = useState(1);
  const [total, setTotal] = useState();
  const [context, setContext] = useState([]);

  const history = useHistory();
  const { historyList, starHistoryAPICall, handleStarShopOpen } = useStarShop();

  useEffect(() => {
    if (!historyList) return;
    setContext((old) => ([
      ...old,
      ...historyList
    ]));
  }, [historyList]);

  useEffect(() => {
    const cnt = Math.ceil(total / (1 * 10));
    setPageCnt(cnt > 1 ? cnt : 0);
  }, [total])

  useEffect(() => {
    starHistoryAPICall();
  }, []);

  const handleAdd = useCallback(() => {
    if (page <= pageCnt) {
      setPage((page+1));
      starHistoryAPICall(page + 1);
    }
  }, [page, pageCnt]);

  return (
    <div className="layout-def bg_gray2">
      <div className="header">
        <div className="inner">
          <div className="headerBox center">
            <div className="w1280">
              <div className="headerBox_head">
                <button 
                  className="btn-close-wrap"
                  onClick={() => history.goBack()}
                >닫기
                </button>
              </div>
            </div>
          </div>
          <div className="star_header">
            <div className="cont">
              <div className="left">
                <div className="tit">AI 바로셈에서 모은 내 별</div>
              </div>
              <div className="right">
                <StarCntBtn
                  setTotal={setTotal}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container h100">
        <div className="inner">
          <div className="star_list">
            {
              context && context.length > 0
                ? (
                  <>
                   {context.map((item, index) => (
                      <article key={index}>
                        <div className="tit" style={{height: 'auto'}}>
                         
                          AI바로셈 학습완료<br />
                          {item.detail.DTL_CNTT_01}
                         
                        </div>
                       <div className="date">
                         {moment(toDate(item.regDateTime)).format("YYYY.MM.DD HH:mm")}
                       </div>
                       <div className="num">{item.useAddPoint}</div>
                      </article>

                   ))}
                    {
                      (context && pageCnt > page) && (
                        <div className="more">
                          <button
                            type="button"
                            className="btn btn-white"
                            onClick={handleAdd}
                          >
                            더보기
                          </button>
                        </div>
                      )
                    }
                    {
                      (info.entryType === TYPE.ENTRY_TYPE.GM_APP
                        || info.entryType === TYPE.ENTRY_TYPE.GM
                        || info.entryType === TYPE.ENTRY_TYPE.CP) && (
                        <StarShopBtn handleStarShopOpen={handleStarShopOpen}/>
                      )
                    }
                  </>
                )
                : (
                  <div className="empty_wrap">
                    <div className="empty">
                      <p>아직 완료한 학습이 없습니다.</p>
                    </div>
                  </div>
                )
            }
            {
              (info.entryType === TYPE.ENTRY_TYPE.GM_APP
                || info.entryType === TYPE.ENTRY_TYPE.GM
                || info.entryType === TYPE.ENTRY_TYPE.CP) && (
                <StarShopBtn handleStarShopOpen={handleStarShopOpen}/>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default StarShopHistory;